import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreatePoolDto } from '../../types/pool-plans.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useCreate = () => {
  const { mutate: create, isPending } = useAppMutation([QueryKey.CREATE_POOL], {
    mutationFn: ({ companyId, data }: { companyId: string; data: CreatePoolDto }) =>
      ApiService.post(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'pools'] },
        { body: data },
      ),
  });
  return { create, isPending };
};
